/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectChangesSettingsControllerFindOneQueryResponse, ProjectChangesSettingsControllerFindOnePathParams, ProjectChangesSettingsControllerFindOneQueryParams, ProjectChangesSettingsControllerFindOne400, ProjectChangesSettingsControllerFindOne401, ProjectChangesSettingsControllerFindOne403, ProjectChangesSettingsControllerFindOne404 } from "../../models/changeOrdersController/ProjectChangesSettingsControllerFindOne";

function getProjectChangesSettingsControllerFindOneUrl(projectId: ProjectChangesSettingsControllerFindOnePathParams["projectId"]) {
  const res = { method: 'GET', url: `/api/v1/project-changes-settings/${projectId}` as const }  
  return res
}

/**
 * @summary Get Changes settings for a project
 * {@link /api/v1/project-changes-settings/:projectId}
 */
export async function projectChangesSettingsControllerFindOne(projectId: ProjectChangesSettingsControllerFindOnePathParams["projectId"], params?: ProjectChangesSettingsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectChangesSettingsControllerFindOneQueryResponse, ResponseErrorConfig<ProjectChangesSettingsControllerFindOne400 | ProjectChangesSettingsControllerFindOne401 | ProjectChangesSettingsControllerFindOne403 | ProjectChangesSettingsControllerFindOne404>, unknown>({ method : "GET", url : getProjectChangesSettingsControllerFindOneUrl(projectId).url.toString(), params, ... requestConfig })  
  return res.data
}